import 'katex/dist/katex.min.css';
import LatexLib from 'react-latex-next';
import {LatexProps} from 'react-latex-next/dist/Latex';

export const Latex = (props: LatexProps) => <LatexLib {...props} />;
